module.exports = __webpack_public_path__ + "static/media/UTURN_RIGHT.7622044a.svg";